import React, { useState } from 'react';
import { PlayingCard } from './PlayingCard';
const exampleHand = [{
  rank: 'K',
  suit: '♥'
}, {
  rank: 'K',
  suit: '♠'
}, {
  rank: '7',
  suit: '♦'
}, {
  rank: '3',
  suit: '♣'
}, {
  rank: '9',
  suit: '♥'
}];
const rankChips: Record<string, number> = {
  '2': 2,
  '3': 3,
  '4': 4,
  '5': 5,
  '6': 6,
  '7': 7,
  '8': 8,
  '9': 9,
  '10': 10,
  J: 10,
  Q: 10,
  K: 10,
  A: 11
};
export function ScoringSystem() {
  const [step, setStep] = useState(0);
  const [animating, setAnimating] = useState(false);
  const baseChips = 10; // One Pair base
  const baseMult = 2; // One Pair base
  const cardChips = rankChips['K'] + rankChips['K']; // scoring cards
  const totalChips = baseChips + cardChips;
  const finalScore = totalChips * baseMult;
  const steps = [{
    title: '第一步：确定牌型',
    desc: '游戏会自动识别你打出的5张牌是什么牌型。这里是"一对K"（One Pair）。',
    highlight: 'hand'
  }, {
    title: '第二步：获得基础筹码',
    desc: '每种牌型都有固定的基础筹码值。一对的基础筹码是 10。',
    highlight: 'base-chips'
  }, {
    title: '第三步：计算牌面筹码',
    desc: '参与组合的牌（这里是两张K）会贡献自己的筹码值。每张K = 10筹码，两张K = 20筹码。',
    highlight: 'card-chips'
  }, {
    title: '第四步：筹码相加',
    desc: '基础筹码（10）+ 牌面筹码（20）= 总筹码（30）。',
    highlight: 'total-chips'
  }, {
    title: '第五步：乘以倍率',
    desc: '总筹码 × 倍率 = 最终得分！一对的基础倍率是 ×2，所以 30 × 2 = 60分。',
    highlight: 'final'
  }];
  const nextStep = () => {
    if (step < steps.length - 1) {
      setAnimating(true);
      setTimeout(() => {
        setStep(s => s + 1);
        setAnimating(false);
      }, 150);
    }
  };
  const prevStep = () => {
    if (step > 0) setStep(s => s - 1);
  };
  const reset = () => setStep(0);
  const currentStep = steps[step];
  return <div className="space-y-8" data-id="element-255">
      {/* Core concept */}
      <div className="panel p-6 text-center" data-id="element-256">
        <h3 className="text-xl font-bold mb-4" style={{
        color: '#FFD700',
        fontFamily: 'Cinzel, serif'
      }} data-id="element-257">
          核心公式
        </h3>
        <div className="flex items-center justify-center gap-4 flex-wrap" data-id="element-258">
          <div className="text-center" data-id="element-259">
            <div className="chip-badge px-6 py-3 rounded-xl text-2xl number-mono animate-pulse-glow" data-id="element-260">
              筹码 Chips
            </div>
            <div className="text-xs mt-2" style={{
            color: '#9080b0'
          }} data-id="element-261">
              牌型基础值 + 牌面值
            </div>
          </div>
          <div className="text-3xl font-bold" style={{
          color: '#FFD700'
        }} data-id="element-262">
            ×
          </div>
          <div className="text-center" data-id="element-263">
            <div className="mult-badge px-6 py-3 rounded-xl text-2xl number-mono animate-pulse-glow" data-id="element-264">
              倍率 Mult
            </div>
            <div className="text-xs mt-2" style={{
            color: '#9080b0'
          }} data-id="element-265">
              牌型基础倍率
            </div>
          </div>
          <div className="text-3xl font-bold" style={{
          color: '#7060a0'
        }} data-id="element-266">
            =
          </div>
          <div className="text-center" data-id="element-267">
            <div className="score-badge px-6 py-3 rounded-xl text-2xl number-mono animate-pulse-glow" data-id="element-268">
              最终得分
            </div>
            <div className="text-xs mt-2" style={{
            color: '#9080b0'
          }} data-id="element-269">
              需要超过盲注分数
            </div>
          </div>
        </div>
      </div>

      {/* Step by step demo */}
      <div data-id="element-270">
        <h3 className="text-lg font-bold mb-4" style={{
        color: '#FFD700',
        fontFamily: 'Cinzel, serif'
      }} data-id="element-271">
          🎓 逐步演示：一对K的得分计算
        </h3>

        {/* Progress bar */}
        <div className="flex gap-1 mb-6" data-id="element-272">
          {steps.map((_, i) => <button key={i} onClick={() => setStep(i)} className="flex-1 h-2 rounded-full transition-all duration-300" style={{
          background: i <= step ? '#FFD700' : 'rgba(255,215,0,0.2)',
          boxShadow: i === step ? '0 0 8px rgba(255,215,0,0.5)' : 'none'
        }} data-id="element-273" />)}
        </div>

        <div className="panel p-5" data-id="element-274">
          {/* Cards display */}
          <div className="flex gap-2 justify-center mb-6 flex-wrap" data-id="element-275">
            {exampleHand.map((card, i) => {
            const isScoring = card.rank === 'K' && currentStep.highlight !== 'hand';
            const isDimmed = currentStep.highlight === 'card-chips' && card.rank !== 'K';
            return <div key={i} className="relative" data-id="element-276">
                  <PlayingCard rank={card.rank} suit={card.suit} size="md" highlighted={isScoring && currentStep.highlight === 'card-chips'} dimmed={isDimmed} data-id="element-277" />
                  {isScoring && currentStep.highlight === 'card-chips' && <div className="absolute -top-2 -right-2 chip-badge rounded-full w-6 h-6 flex items-center justify-center text-xs number-mono animate-score-pop" data-id="element-278">
                      +{rankChips[card.rank]}
                    </div>}
                </div>;
          })}
          </div>

          {/* Step content */}
          <div className="p-4 rounded-lg mb-4 transition-all duration-300" style={{
          background: 'rgba(0,0,0,0.3)',
          opacity: animating ? 0 : 1,
          transform: animating ? 'translateY(4px)' : 'translateY(0)'
        }} data-id="element-279">
            <div className="font-bold mb-2" style={{
            color: '#FFD700',
            fontFamily: 'Cinzel, serif'
          }} data-id="element-280">
              {currentStep.title}
            </div>
            <p className="text-sm" style={{
            color: '#c0a0e0'
          }} data-id="element-281">
              {currentStep.desc}
            </p>
          </div>

          {/* Score breakdown */}
          <div className="grid grid-cols-2 md:grid-cols-4 gap-3 mb-4" data-id="element-282">
            <div className="p-3 rounded-lg text-center" style={{
            background: step >= 1 ? 'rgba(79,195,247,0.1)' : 'rgba(0,0,0,0.2)',
            border: `1px solid ${step >= 1 ? 'rgba(79,195,247,0.3)' : 'rgba(255,255,255,0.05)'}`,
            transition: 'all 0.3s ease'
          }} data-id="element-283">
              <div className="text-xs mb-1" style={{
              color: '#9080b0'
            }} data-id="element-284">
                牌型基础筹码
              </div>
              <div className="chip-badge px-2 py-1 rounded text-sm number-mono" style={{
              opacity: step >= 1 ? 1 : 0.3
            }} data-id="element-285">
                {step >= 1 ? baseChips : '?'}
              </div>
            </div>
            <div className="p-3 rounded-lg text-center" style={{
            background: step >= 2 ? 'rgba(79,195,247,0.1)' : 'rgba(0,0,0,0.2)',
            border: `1px solid ${step >= 2 ? 'rgba(79,195,247,0.3)' : 'rgba(255,255,255,0.05)'}`,
            transition: 'all 0.3s ease'
          }} data-id="element-286">
              <div className="text-xs mb-1" style={{
              color: '#9080b0'
            }} data-id="element-287">
                牌面筹码
              </div>
              <div className="chip-badge px-2 py-1 rounded text-sm number-mono" style={{
              opacity: step >= 2 ? 1 : 0.3
            }} data-id="element-288">
                {step >= 2 ? `+${cardChips}` : '?'}
              </div>
            </div>
            <div className="p-3 rounded-lg text-center" style={{
            background: step >= 3 ? 'rgba(79,195,247,0.1)' : 'rgba(0,0,0,0.2)',
            border: `1px solid ${step >= 3 ? 'rgba(79,195,247,0.3)' : 'rgba(255,255,255,0.05)'}`,
            transition: 'all 0.3s ease'
          }} data-id="element-289">
              <div className="text-xs mb-1" style={{
              color: '#9080b0'
            }} data-id="element-290">
                总筹码
              </div>
              <div className="chip-badge px-2 py-1 rounded text-sm number-mono" style={{
              opacity: step >= 3 ? 1 : 0.3
            }} data-id="element-291">
                {step >= 3 ? totalChips : '?'}
              </div>
            </div>
            <div className="p-3 rounded-lg text-center" style={{
            background: step >= 4 ? 'rgba(255,68,68,0.1)' : 'rgba(0,0,0,0.2)',
            border: `1px solid ${step >= 4 ? 'rgba(255,68,68,0.3)' : 'rgba(255,255,255,0.05)'}`,
            transition: 'all 0.3s ease'
          }} data-id="element-292">
              <div className="text-xs mb-1" style={{
              color: '#9080b0'
            }} data-id="element-293">
                倍率
              </div>
              <div className="mult-badge px-2 py-1 rounded text-sm number-mono" style={{
              opacity: step >= 4 ? 1 : 0.3
            }} data-id="element-294">
                {step >= 4 ? `×${baseMult}` : '?'}
              </div>
            </div>
          </div>

          {/* Final score */}
          {step >= 4 && <div className="text-center p-4 rounded-xl animate-score-pop" style={{
          background: 'rgba(255,215,0,0.1)',
          border: '2px solid rgba(255,215,0,0.4)',
          boxShadow: '0 0 30px rgba(255,215,0,0.2)'
        }} data-id="element-295">
              <div className="text-sm mb-2" style={{
            color: '#c0a060'
          }} data-id="element-296">
                最终得分
              </div>
              <div className="score-badge px-6 py-2 rounded-xl text-3xl number-mono inline-block" data-id="element-297">
                {finalScore}
              </div>
              <div className="text-xs mt-2" style={{
            color: '#9080b0'
          }} data-id="element-298">
                {totalChips} 筹码 × {baseMult} 倍率 = {finalScore} 分
              </div>
            </div>}

          {/* Navigation */}
          <div className="flex gap-3 mt-4 justify-between" data-id="element-299">
            <button onClick={prevStep} disabled={step === 0} className="px-4 py-2 rounded-lg text-sm font-bold transition-all duration-200" style={{
            background: step === 0 ? 'rgba(0,0,0,0.2)' : 'rgba(255,215,0,0.1)',
            border: `1px solid ${step === 0 ? 'rgba(255,255,255,0.05)' : 'rgba(255,215,0,0.3)'}`,
            color: step === 0 ? '#5040a0' : '#FFD700',
            cursor: step === 0 ? 'not-allowed' : 'pointer'
          }} data-id="element-300">
              ← 上一步
            </button>
            <button onClick={reset} className="px-4 py-2 rounded-lg text-sm transition-all duration-200" style={{
            background: 'rgba(0,0,0,0.2)',
            border: '1px solid rgba(255,255,255,0.1)',
            color: '#9080b0',
            cursor: 'pointer'
          }} data-id="element-301">
              重置
            </button>
            <button onClick={nextStep} disabled={step === steps.length - 1} className="px-4 py-2 rounded-lg text-sm font-bold transition-all duration-200" style={{
            background: step === steps.length - 1 ? 'rgba(0,0,0,0.2)' : 'rgba(255,215,0,0.15)',
            border: `1px solid ${step === steps.length - 1 ? 'rgba(255,255,255,0.05)' : 'rgba(255,215,0,0.4)'}`,
            color: step === steps.length - 1 ? '#5040a0' : '#FFD700',
            cursor: step === steps.length - 1 ? 'not-allowed' : 'pointer',
            boxShadow: step < steps.length - 1 ? '0 0 10px rgba(255,215,0,0.2)' : 'none'
          }} data-id="element-302">
              下一步 →
            </button>
          </div>
        </div>
      </div>

      {/* Blind system */}
      <div className="section-divider" data-id="element-303" />
      <div data-id="element-304">
        <h3 className="text-lg font-bold mb-4" style={{
        color: '#FFD700',
        fontFamily: 'Cinzel, serif'
      }} data-id="element-305">
          🎯 盲注系统（Blinds）
        </h3>
        <p className="text-sm mb-4" style={{
        color: '#b090d0'
      }} data-id="element-306">
          每一关都有一个需要达到的分数目标，称为"盲注"。你需要在规定的出牌次数内达到这个分数。
        </p>
        <div className="grid md:grid-cols-3 gap-4" data-id="element-307">
          <div className="panel p-4 text-center" data-id="element-308">
            <div className="text-3xl mb-2" data-id="element-309">😊</div>
            <div className="font-bold mb-1" style={{
            color: '#60c060',
            fontFamily: 'Cinzel, serif'
          }} data-id="element-310">
              小盲注
            </div>
            <div className="text-xs mb-2" style={{
            color: '#9080b0'
          }} data-id="element-311">
              Small Blind
            </div>
            <div className="score-badge px-3 py-1 rounded-lg text-sm number-mono inline-block" data-id="element-312">
              300分
            </div>
            <p className="text-xs mt-2" style={{
            color: '#7060a0'
          }} data-id="element-313">
              第一关的目标分数，相对容易达到
            </p>
          </div>
          <div className="panel p-4 text-center" data-id="element-314">
            <div className="text-3xl mb-2" data-id="element-315">😤</div>
            <div className="font-bold mb-1" style={{
            color: '#FFD700',
            fontFamily: 'Cinzel, serif'
          }} data-id="element-316">
              大盲注
            </div>
            <div className="text-xs mb-2" style={{
            color: '#9080b0'
          }} data-id="element-317">
              Big Blind
            </div>
            <div className="score-badge px-3 py-1 rounded-lg text-sm number-mono inline-block" data-id="element-318">
              450分
            </div>
            <p className="text-xs mt-2" style={{
            color: '#7060a0'
          }} data-id="element-319">
              第二关，需要更好的牌型或小丑牌加持
            </p>
          </div>
          <div className="panel p-4 text-center" data-id="element-320">
            <div className="text-3xl mb-2" data-id="element-321">😈</div>
            <div className="font-bold mb-1" style={{
            color: '#ff4444',
            fontFamily: 'Cinzel, serif'
          }} data-id="element-322">
              Boss盲注
            </div>
            <div className="text-xs mb-2" style={{
            color: '#9080b0'
          }} data-id="element-323">
              Boss Blind
            </div>
            <div className="score-badge px-3 py-1 rounded-lg text-sm number-mono inline-block" data-id="element-324">
              600分
            </div>
            <p className="text-xs mt-2" style={{
            color: '#7060a0'
          }} data-id="element-325">
              最难！还有特殊的负面效果
            </p>
          </div>
        </div>
      </div>

      {/* Joker boost preview */}
      <div className="panel p-5" style={{
      background: 'rgba(180,79,255,0.05)',
      border: '1px solid rgba(180,79,255,0.3)'
    }} data-id="element-326">
        <h4 className="font-bold mb-3" style={{
        color: '#b44fff',
        fontFamily: 'Cinzel, serif'
      }} data-id="element-327">
          🃏 小丑牌如何提升得分？
        </h4>
        <p className="text-sm mb-3" style={{
        color: '#c0a0e0'
      }} data-id="element-328">
          小丑牌可以大幅提升你的筹码和倍率。例如：
        </p>
        <div className="grid md:grid-cols-2 gap-3 text-sm" data-id="element-329">
          <div className="p-3 rounded-lg" style={{
          background: 'rgba(79,195,247,0.1)',
          border: '1px solid rgba(79,195,247,0.2)'
        }} data-id="element-330">
            <div className="font-bold mb-1" style={{
            color: '#4fc3f7'
          }} data-id="element-331">
              +筹码型小丑
            </div>
            <div style={{
            color: '#b090d0'
          }} data-id="element-332">
              例：每出一张红心牌，+50筹码
            </div>
            <div className="mt-1 number-mono text-xs" style={{
            color: '#4fc3f7'
          }} data-id="element-333">
              30 + 50 = 80筹码
            </div>
          </div>
          <div className="p-3 rounded-lg" style={{
          background: 'rgba(255,68,68,0.1)',
          border: '1px solid rgba(255,68,68,0.2)'
        }} data-id="element-334">
            <div className="font-bold mb-1" style={{
            color: '#ff6666'
          }} data-id="element-335">
              +倍率型小丑
            </div>
            <div style={{
            color: '#b090d0'
          }} data-id="element-336">
              例：每出一对，+4倍率
            </div>
            <div className="mt-1 number-mono text-xs" style={{
            color: '#ff6666'
          }} data-id="element-337">
              2 + 4 = 6倍率
            </div>
          </div>
          <div className="p-3 rounded-lg" style={{
          background: 'rgba(255,140,0,0.1)',
          border: '1px solid rgba(255,140,0,0.2)'
        }} data-id="element-338">
            <div className="font-bold mb-1" style={{
            color: '#ff8c00'
          }} data-id="element-339">
              ×倍率型小丑
            </div>
            <div style={{
            color: '#b090d0'
          }} data-id="element-340">
              例：倍率×1.5（乘法！）
            </div>
            <div className="mt-1 number-mono text-xs" style={{
            color: '#ff8c00'
          }} data-id="element-341">
              6 × 1.5 = 9倍率
            </div>
          </div>
          <div className="p-3 rounded-lg" style={{
          background: 'rgba(255,215,0,0.1)',
          border: '1px solid rgba(255,215,0,0.2)'
        }} data-id="element-342">
            <div className="font-bold mb-1" style={{
            color: '#FFD700'
          }} data-id="element-343">
              最终得分
            </div>
            <div style={{
            color: '#b090d0'
          }} data-id="element-344">
              80筹码 × 9倍率
            </div>
            <div className="mt-1 number-mono text-xs" style={{
            color: '#FFD700'
          }} data-id="element-345">
              = 720分！（原来只有60分）
            </div>
          </div>
        </div>
      </div>
    </div>;
}